import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-130b0c00")

_pushScopeId("data-v-130b0c00")
const _hoisted_1 = { class: "dt-open-api-left-menu-content" }
const _hoisted_2 = { class: "dt-open-api-left-menu-personal-img" }
const _hoisted_3 = {
  key: 0,
  src: "https://fs.iclass30.com///aliba/avatar/default/default.png"
}
const _hoisted_4 = {
  key: 0,
  class: "dt-open-api-left-menu-personal-info"
}
const _hoisted_5 = {
  key: 0,
  class: "dt-open-api-left-menu-personal-mobile"
}
const _hoisted_6 = { class: "dt-open-api-left-menu-personal-name" }
const _hoisted_7 = { class: "dt-open-api-left-menu-personal-more" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-left-menu-personal-type" }, "企业开发者", -1)
const _hoisted_9 = { class: "dt-open-api-left-menu-personal-state" }
const _hoisted_10 = {
  key: 1,
  class: "dt-open-api-left-menu-personal-info"
}
const _hoisted_11 = { class: "dt-open-api-left-menu-personal-app-name" }
const _hoisted_12 = { class: "dt-open-api-left-menu-box" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["dt-open-api-left-menu-personal-box clearfix", _ctx.isAppInside ? 'dt-open-api-left-inside':'']
    }, [
      _createVNode("div", _hoisted_2, [
        (!_ctx.isAppInside)
          ? (_openBlock(), _createBlock("img", _hoisted_3))
          : (_openBlock(), _createBlock("img", {
              key: 1,
              src: `${_ctx.aliyunPath}${_ctx.application.logo}`
            }, null, 8, ["src"]))
      ]),
      (!_ctx.isAppInside)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (_ctx.isShowMobile)
              ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.mobile), 1))
              : _createCommentVNode("", true),
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.enterpriseFullName), 1),
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.examineState === 0 ? '未审核': _ctx.examineState === 1 ? '已通过':'不通过'), 1)
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_10, [
            _createVNode("p", _hoisted_11, _toDisplayString(_ctx.application.title), 1)
          ]))
    ], 2),
    _createVNode("div", _hoisted_12, [
      _createVNode("ul", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.menuList, (item) => {
          return (_openBlock(), _createBlock("li", {
            class: _ctx.curMenu.id === item.id ? 'active':'',
            key: item.id,
            onClick: $event => (_ctx.clickMenuItem(item))
          }, [
            _createVNode("span", null, _toDisplayString(item.title), 1)
          ], 10, ["onClick"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
})